import theme from "@shared/utils/themeColors";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { SidebarLinkItem } from "./types";

interface SidebarItemProps {
	item: SidebarLinkItem;
	badge?: React.ReactNode;
}

export const SidebarItem: React.FC<SidebarItemProps> = ({ item, badge }) => {
	const location = useLocation();
	const { pathname, search } = location;
	const fullPath = pathname + search;

	const isActive = (): boolean => {
		if (item.excludedMatch) {
			const isExcluded = Array.isArray(item.excludedMatch)
				? item.excludedMatch.some((match) => fullPath.includes(match))
				: fullPath.includes(item.excludedMatch);
			if (isExcluded) return false;
		}

		if (item.exact) {
			return pathname === item.path.split("?")[0];
		}
		if (item.pathMatch) {
			return Array.isArray(item.pathMatch)
				? item.pathMatch.some((match) => fullPath.includes(match))
				: fullPath.includes(item.pathMatch);
		}
		return fullPath.includes(item.path);
	};

	const active = isActive();
	const icon = typeof item.icon === "function" ? item.icon(active) : item.icon;

	return (
		<li
			className={`pl-4 pr-3 py-2 rounded-lg mb-0.5 last:mb-0 bg-[linear-gradient(135deg,var(--tw-gradient-stops))] ${active && theme.bg.gradientPrimary
				}`}
		>
			<NavLink
				end={item.exact}
				to={item.path}
				className={`block ${theme.text.primary} truncate transition duration-150 ${active ? "" : "hover:text-gray-900 dark:hover:text-white"
					}`}
			>
				<div className="flex items-center justify-between">
					<div className="flex items-center">
						{icon}
						<span className="text-sm font-medium ml-4 md:opacity-0 md:sidebar-expanded:opacity-100 xl:opacity-100 duration-200">
							{item.label}
						</span>
					</div>
					{badge}
				</div>
			</NavLink>
		</li>
	);
};
